import React from 'react'
import Layout from '../components/Layout'
import Seo from '../components/Seo'

export default () => (
	<Layout>
		<Seo
			title="Sample page"
			keywords={[`blog`, `gatsby`, `javascript`, `react`]}
		/>
		<div className="inner-wrap-container">
			<div className="inner-wrap visible fade-in">
				<div className="single-article">
					{/* OPTIONAL: Featured Image: */}
					<div
						className="featured-image"
						style={{
							backgroundImage: `url(https://source.unsplash.com/random/1024)`,
						}}
					/>
					{/* OPTIONAL: Featured Image: */}

					<div className="post-content m-auto">
						<h1 className="title">Sample Page</h1>
						<div className="content">This is a sample page.</div>
					</div>
				</div>
			</div>
		</div>
	</Layout>
)
